module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrMedium.826b245.ttf";